<template>
  <div class="container">
    <!-- <div class="timeline" v-if="filteredEventsByNational && filteredEventsByNational.length">
      <ul>
        <li v-for="(ev, index) in filteredEventsByNational" :key="ev._id" :class="{ 'home': ev.isHomeTeam, 'away': !ev.isHomeTeam }">
          <div class="timeline-content">
          <h2 class="scores"> {{ scoreByIndex(index) }}</h2>
          <h3 class="date event-time" v-if="ev.min && ev.sec && ev.min > 0 || ev.sec > 0">{{ padStart(ev.min) }}:{{ padStart(ev.sec) }}</h3>
          <h1>
            <ion-icon slot="start" :icon="(nationalId === 8 || nationalId === 12) ? footballOutline : americanFootballOutline" v-if="ev.eventType === 'scoring' "></ion-icon> 
            <ion-icon slot="start" :icon="peopleOutline" v-else-if="ev.eventType === 'movement'"></ion-icon> 
            {{ ev.name }}
            
          </h1>
          <p v-if="ev.eventType === 'scoring' " class="event-player"> {{ get(ev, 'meta.player.firstName') }} {{ get(ev, 'meta.player.lastName') }} </p>
          <p v-if="ev.eventType === 'movement' && ev.meta && ev.meta.off && ev.meta.off.firstName " class="event-player"> 
            {{ ev.meta.off.firstName}} {{ ev.meta.off.lastName }} 
            <ion-icon :icon="arrowBack" color="danger" v-if="ev.meta.off && ev.meta.on && ev.meta.off.firstName && ev.meta.on.firstName"></ion-icon>
          </p>
          <p v-if="ev.eventType === 'movement' && ev.meta && ev.meta.on && ev.meta.on.firstName " class="event-player"> 
            {{ ev.meta.on.firstName }} {{ ev.meta.on.lastName }} 
            <ion-icon :icon="arrowForward" color="success"></ion-icon>
          </p>
          </div>
        </li>
      </ul>
      <ul>
        <li v-for="(ev, index) in penaltyEvents" :key="`pen-${ev._id}`" :class="{ 'home': ev.isHomeTeam, 'away': !ev.isHomeTeam }">
          <div class="timeline-content">
          <h3 class="date event-time" v-if="ev.min && ev.sec && ev.min > 0 || ev.sec > 0">{{ padStart(ev.min) }}:{{ padStart(ev.sec) }}</h3>
          <h3 class="date event-time">Penalty Shootout - {{ penaltyScoreByIndex(index) }}</h3>
          <h1>
            <ion-icon slot="start" :icon="(nationalId === 8 || nationalId === 12) ? footballOutline : americanFootballOutline" v-if="ev.eventType === 'scoring' "></ion-icon> 
            <ion-icon slot="start" :icon="peopleOutline" v-else-if="ev.eventType === 'movement'"></ion-icon> 
            {{ ev.name }}
          </h1>
          <p v-if="ev.eventType === 'scoring' " class="event-player"> {{ get(ev, 'meta.player.firstName') }} {{ get(ev, 'meta.player.lastName') }} </p>
          <p v-if="ev.eventType === 'movement' && ev.meta && ev.meta.off && ev.meta.off.firstName " class="event-player"> 
            {{ ev.meta.off.firstName}} {{ ev.meta.off.lastName }} 
            <ion-icon :icon="arrowBack" color="danger" v-if="ev.meta.off && ev.meta.on && ev.meta.off.firstName && ev.meta.on.firstName"></ion-icon>
          </p>
          <p v-if="ev.eventType === 'movement' && ev.meta && ev.meta.on && ev.meta.on.firstName " class="event-player"> 
            {{ ev.meta.on.firstName }} {{ ev.meta.on.lastName }} 
            <ion-icon :icon="arrowForward" color="success"></ion-icon>
          </p>
          </div>
        </li>
      </ul>
    </div> -->

    <!-- <div class="timeline-std" v-if="filteredEventsByNational && filteredEventsByNational.length">
        <div class="header">Events</div>
        <div v-for="(ev) in filteredEventsByNational" :key="ev._id" :class="{ 'timeline-event': true, 'home': ev.isHomeTeam, 'away': !ev.isHomeTeam }">
          <div class="timeline-content">
            <div class="d-grid align-center">
              <div class="d-flex gap-025 align-center" :class="{ 'justify-end': !ev.isHomeTeam }">
                <small class="date">{{ ev.min > 0 || ev.sec > 0 ? `(${padStart(ev.min) }:${padStart(ev.sec)})` : "0'" }}</small>
                <ion-icon slot="start" :icon="(nationalId === 8 || nationalId === 12) ? footballOutline : americanFootballOutline" v-if="ev.eventType === 'scoring' "></ion-icon> 
                <ion-icon slot="start" :icon="peopleOutline" v-else-if="ev.eventType === 'movement'"></ion-icon> 
                <span>{{ ev.name }}</span>
              </div>
              <div>
                <p v-if="ev.eventType === 'scoring' " class="event-player" :class="{ 'text-right': !ev.isHomeTeam }"> {{ get(ev, 'meta.player.firstName') }} {{ get(ev, 'meta.player.lastName') }} </p>
                <p v-if="ev.eventType === 'movement' && ev.meta && ev.meta.off && ev.meta.off.firstName " class="event-player" :class="{ 'text-right': !ev.isHomeTeam }"> 
                  <ion-icon :icon="arrowBack" color="danger" v-if="ev.meta.off && ev.meta.on && ev.meta.off.firstName && ev.meta.on.firstName"></ion-icon>
                  {{ ev.meta.off.firstName}} {{ ev.meta.off.lastName }} 
                </p>
                <p v-if="ev.eventType === 'movement' && ev.meta && ev.meta.on && ev.meta.on.firstName " class="event-player" :class="{ 'text-right': !ev.isHomeTeam }"> 
                  <ion-icon :icon="arrowForward" color="success"></ion-icon>
                  {{ ev.meta.on.firstName }} {{ ev.meta.on.lastName }} 
                </p>
              </div>
            </div>
          </div>
        </div>
    </div> -->
    
    <div class="timeline-grid" v-if="filteredEventsByNational && filteredEventsByNational.length">
      <div class="header c-white">Events</div>
      <div v-for="(ev, index) in filteredEventsByNational" :key="ev._id" class="grid-row">
        <div class="home align-center">
          <span  v-if="ev.isHomeTeam" class="c-white">{{ ev.name }}</span>
          <p class="event-player"  v-if="ev.isHomeTeam && ev.meta && ev.meta.player">{{ get(ev, 'meta.player.firstName') }} {{ get(ev, 'meta.player.lastName') }}</p>
        </div>
        <div class="time-score">
          <small class="date c-white">{{ ev.min > 0 || ev.sec > 0 ? `(${padStart(ev.min)}:${padStart(ev.sec)})` : "0'" }}</small>
          <h4 class="scores">{{ scoreByIndex(index) }}</h4>
        </div>
        <div class="away align-center">
          <span  v-if="!ev.isHomeTeam" class="c-white">{{ ev.name }}</span>
          <p class="event-player"  v-if="!ev.isHomeTeam && ev.meta && ev.meta.player">{{ get(ev, 'meta.player.firstName') }} {{ get(ev, 'meta.player.lastName') }}</p>
        </div>
      </div>
    </div>

    <ion-grid class="no-event-container" v-else>
      <ion-text color="secondary">
        <h1 class="event-header">No Event Data</h1>
      </ion-text>
    </ion-grid>
  </div>
</template>

<script>
import _, {get} from 'lodash';
import {
  arrowBack,
  arrowForward,
  footballOutline,
  americanFootballOutline,
  peopleOutline,
} from "ionicons/icons";

export default {
  name: 'Timeline',
  props: {
    events: {
      type: Array,
      required: false,
    },
    periodSegment: {
      type: Number,
      required: false,
    }
  },
  setup() {
    return {
      arrowBack,
      arrowForward,
      footballOutline,
      americanFootballOutline,
      peopleOutline,
    }
  },
  data() {
    return {
      get,
      nationalId : +process.env.VUE_APP_NATIONAL_ID,
      // sorted: [],
    }
  },
  mounted() {
    // this.sorted = _.sortBy(Object.assign([], this.events), ['min', 'sec']);
  },
  computed: {
    sorted() {
      let events = _.sortBy([...this.events], ['min', 'sec']);
      if (this.periodSegment > 0) {
        events = _.filter(events, e => {
          const ePeriod = +_.get(e, 'period');
          return ePeriod === +this.periodSegment;
        });
      }
      return events;
    },
    filteredEventsByNational() {
      const events = this.sorted;
      const nationalId = +process.env.VUE_APP_NATIONAL_ID;
      if ([8,12].includes(nationalId)) return events.filter(e => e.name && !e.name.toLowerCase().includes('missed')) 
      return events.filter(ev => ev.period !== 9999);
    },
    penaltyEvents() {
      return _.filter(this.sorted, e => e.eventType === 'scoring' && e.name.toLowerCase().includes('penalty') && e.period === 9999);
    }
  },
  methods: {
    penaltyScoreByIndex(index) {
      const { penaltyEvents } = this;
      const sliced = penaltyEvents.slice(0, index + 1);
      const homeEvents = _.filter(sliced, e => e.isHomeTeam && !e.name.toLowerCase().includes('miss') );
      const awayEvents = _.filter(sliced, e => !e.isHomeTeam && !e.name.toLowerCase().includes('miss') );
      // const homeScores = _.sumBy(homeEvents, 'value'); 
      // const awayScores = _.sumBy(awayEvents, 'value');
      return `${homeEvents.length} - ${awayEvents.length}`;
    },
    padStart: num => String(num).padStart(2, '0'),
    scoreByIndex(index) {
      const availableEvents = this.filteredEventsByNational.slice(0, index + 1);
      const homeEventsUntilIndex = availableEvents.filter(e => e.isHomeTeam === true).slice(0, index + 1);
      const awayEventsUntilIndex = availableEvents.filter(e => e.isHomeTeam === false).slice(0, index + 1);
      const homeScoreTillIndex = homeEventsUntilIndex.filter(e => e.eventType === 'scoring').reduce((acc, curr) => acc + curr.value, 0);
      const awayScoreTillIndex = awayEventsUntilIndex.filter(e => e.eventType === 'scoring').reduce((acc, curr) => acc + curr.value, 0);
      if (index === 0 || index === 1) {
        console.log({
          homeEventsUntilIndex,
          awayEventsUntilIndex,
          homeScoreTillIndex,
          awayScoreTillIndex,
        })
      }
      return `${homeScoreTillIndex}:${awayScoreTillIndex}`;
    }
  }
  
}
</script>

<style scoped lang="scss">
/* Assemble Sports Fonts */
@font-face {
	font-family: 'BrownStd-Bold';
	src: url('../assets/fonts/BrownStd-Bold.otf') format('truetype'); /* IE9 Compat Modes */
}
@font-face {
	font-family: 'BrownStd-Regular';
	src: url('../assets/fonts/BrownStd-Regular.otf') format('truetype'); /* IE9 Compat Modes */
}
@font-face {
	font-family: 'BrownStd-Light';
	src: url('../assets/fonts/BrownStd-Light.otf') format('truetype'); /* IE9 Compat Modes */
}

.scores {
  color: $highlight;
  font-family: 'BrownStd-Bold';
  margin: 0;
}

.container {
  // width: 100%;
  margin: 0 1rem;
  background: #171717;
  border-radius: 24px;
  padding: 0;
  max-width: 768px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8rem;
  @media (min-width: 768px) {
    min-width: 728px;
  }

  .timeline-std {
    width: 100%;

    .header {
      background: hsl(0 0% 11% / 1);
      letter-spacing: -0.05rem;
      font-weight: 'BrownStd-Bold';
      padding: 0.5rem 1.5rem;
      // text-align: right;
      border-top-left-radius: 24px;
      border-top-right-radius: 24px;
    }

    .timeline-event {
      display: flex;
      gap: 0.5rem;
      padding: 0.5rem 1.5rem;
      &:not(:last-child) {
        border-bottom: 0.5px solid rgba(#EBEBEB, 0.1);
      }
      &.away {
        justify-content: end;
      }

      .timeline-content {
        display: flex;
        gap: 0.5rem;
        align-items: center;
      }
    }
  }
  /* background-color: #111; */
}

.container {
  max-width: 768px;
  margin: 0 auto;
  background: #171717;
  border-radius: 24px;
  padding: 0;
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
}

.timeline-grid {
  width: 100%;
  display: grid;
  gap: 1rem;

  .grid-row {
    display: grid;
    grid-template-columns: 1fr 3rem 1fr;
    gap: 1rem;
    padding: 0.5rem 1.5rem;
    &:not(:last-child) {
      border-bottom: 0.5px solid rgba(#EBEBEB, 0.1);
    }

    .home {
      display: grid;
      justify-items: right;
    }
  }

  .header {
    background: hsl(0 0% 11% / 1);
    letter-spacing: -0.05rem;
    font-weight: 'BrownStd-Bold';
    padding: 0.5rem 1.5rem;
    // text-align: right;
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
  }

  .time-score {
    display: grid;
    justify-items: center;
  }

  .timeline-event {
    display: flex;
    gap: 0.5rem;
    padding: 0.5rem 1.5rem;
    border-bottom: 0.5px solid rgba(#EBEBEB, 0.1);
    &.away {
      justify-content: end;
    }

    .timeline-content {
      display: flex;
      gap: 0.5rem;
      align-items: center;
    }
  }
}

.grid-row {
  display: contents;
}

.event-player {
  font-family: 'BrownStd-Light';
  margin: 0;
  font-style: normal;
  font-weight: normal;
  font-size: .8rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  /* color: black; */
  color: #aaa !important;
}

.timeline {
  width: 85%;
  min-height: 10vh;
  padding-top: 4.5rem;
  padding-bottom: 4.5rem;
  height: auto;
  max-width: 800px;
  margin: 0 auto;
  position: relative;
}

.timeline ul {
  list-style: none;
}

.timeline ul li:before {
  /* box-shadow: inset 0 0 2000px rgba(35, 37, 40, .2); */
  /* filter: blur(1rem); */
  /* filter: blur(2rem); */
  content: "";
  position: absolute;
  background: inherit;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.timeline ul li {
  padding: .8rem;
  background-color: inherit;
  color: white;
  border-radius: 0.7rem;
  margin-bottom: 1rem;
  margin-left: 1.10rem;
  margin-right: 1.4rem;
}

.timeline ul li:last-child {
  margin-bottom: 0;
}

.timeline-content h1 {
  line-height: 30px;
  margin: 0;
  // margin-bottom: 10px;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: 600;
  display: flex;
  align-items: center;
  line-height: 137.4%;
  letter-spacing: -0.05em;
  color: #fff;
  /* color: black; */

  font-size: 1rem;
}

@media (max-width: 380px) {
  .timeline { width: 80% }
  .timeline-content h1 { font-size: .8rem; }
}

ion-icon {
  margin-right: 0.25rem;
}

.timeline-content .date {
  font-weight: 300;
  margin-bottom: 10px;
  letter-spacing: 2px;
  font-family: 'BrownStd-Regular';
  font-weight: bold;
  font-size: .9rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: white !important;
}

.timeline:before {
  content: "";
  position: absolute;
  margin: 4.5rem 0;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 1px;
  height: 100%;
  /* background-color:rgba(255,255,255,.5); */
  /* background-color:rgba(0,0,0,.2); */
  background-color: #2d352d;
}

.timeline ul li {
  width: 50%;
  position: relative;
  margin-bottom: 3.15rem;
}

@media (max-width: 728px) {
  .timeline ul li {
    width: unset;
  }
}

.timeline ul li.home {
  float: left;
  // clear: right;
  transform: translateX(-4rem);
  border-radius: 1rem;
  display: flex;
  justify-content: flex-end;
}

.timeline ul li.home .timeline-content{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.timeline ul li.away {
  float: right;
  // clear: left;
  transform: translateX(2rem);
  border-radius: 1rem;
  display: flex;
  justify-content: flex-start;
}

.timeline ul li.away .timeline-content{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.timeline ul li.home::before {
  /* transform: translate(50%, -50%);
  right: -30px; */
}

.timeline ul li.away::before {
  /* transform: translate(-50%, -50%);
  left: -30px; */
}

.timeline-content .date {
  // position: absolute;
  top: -1.5rem;
  /* top: -2.5rem; */
}
.timeline ul li:hover::before {
  /* background-color: $highlight; */
}

.no-event-container {
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.no-event-container:before {
  box-shadow: inset 0 0 2000px rgba(35, 37, 40, .2);
  filter: blur(1rem);
  /* filter: blur(2rem); */
  content: "";
}

.event-header {
  align-items: flex-start;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  /* margin-bottom: 1rem; */
  padding-left: 0;

  letter-spacing: 0.02em;

  /* color: #2D3A45 */
  color: #fff;
}


</style>